var _g, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgPayshapInfo1 = function SvgPayshapInfo1(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3168_6832)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59 64.5V3.5C59 1.84315 57.6569 0.5 56 0.5H8C6.34315 0.5 5 1.84315 5 3.5V64.5",
    stroke: "#F15A22",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3168_6832)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.334 29.5137H39.6673",
    stroke: "#F15A22",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 25.1803V19.5137",
    stroke: "#F15A22",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 25.1803V19.5137",
    stroke: "#F15A22",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 25.1803V19.5137",
    stroke: "#F15A22",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 25.1803V19.5137",
    stroke: "#F15A22",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7675 8.67974C31.9066 8.5804 32.0934 8.5804 32.2325 8.67974L41.4843 15.2882C41.801 15.5144 41.6409 16.0137 41.2518 16.0137H22.7482C22.3591 16.0137 22.199 15.5144 22.5157 15.2882L31.7675 8.67974Z",
    fill: "#F15A22"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 18.5449,
    y: 37.9387,
    width: 26.9085,
    height: 2.24238,
    fill: "#FC4D0F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.5449,
    y: 44.6658,
    width: 26.9085,
    height: 2.24238,
    fill: "#FC4D0F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 52.5,
    width: 26,
    height: 8,
    rx: 1,
    fill: "#F15A22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1497 58.1816C31.0472 58.1816 30.9481 58.2138 30.8689 58.2725C30.7897 58.3313 30.7355 58.413 30.7155 58.5039C30.6956 58.5947 30.711 58.689 30.7593 58.7707C30.8076 58.8523 30.8856 58.9163 30.9803 58.9518C31.0749 58.9872 31.1802 58.9919 31.2782 58.965C31.3762 58.9381 31.4609 58.8814 31.5177 58.8044C31.5746 58.7273 31.6002 58.6349 31.5902 58.5427C31.5802 58.4506 31.5351 58.3644 31.4627 58.2989C31.4218 58.2615 31.373 58.2319 31.3192 58.2118C31.2655 58.1916 31.2078 58.1814 31.1497 58.1816Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4632 55.2827C31.3916 55.2181 31.3004 55.1741 31.2012 55.1563C31.1019 55.1385 30.999 55.1477 30.9056 55.1828C30.8121 55.2179 30.7323 55.2772 30.676 55.3533C30.6198 55.4294 30.5898 55.5188 30.5898 55.6104C30.5898 55.7019 30.6198 55.7913 30.676 55.8674C30.7323 55.9435 30.8121 56.0028 30.9056 56.0379C30.999 56.073 31.1019 56.0822 31.2012 56.0644C31.3004 56.0466 31.3916 56.0026 31.4632 55.938C31.5112 55.8952 31.5492 55.8443 31.5752 55.7881C31.6013 55.7319 31.6147 55.6716 31.6147 55.6107C31.6147 55.5498 31.6013 55.4895 31.5752 55.4333C31.5492 55.3771 31.5112 55.3262 31.4632 55.2834",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2965 56.0361C32.2248 55.9716 32.1337 55.9277 32.0344 55.9101C31.9352 55.8924 31.8325 55.9017 31.739 55.9368C31.6457 55.972 31.566 56.0313 31.5099 56.1073C31.4537 56.1834 31.4238 56.2728 31.4238 56.3643C31.4238 56.4557 31.4537 56.5451 31.5099 56.6212C31.566 56.6972 31.6457 56.7566 31.739 56.7917C31.8325 56.8268 31.9352 56.8361 32.0344 56.8184C32.1337 56.8008 32.2248 56.7569 32.2965 56.6925C32.3445 56.6497 32.3827 56.5987 32.4087 56.5425C32.4348 56.4863 32.4481 56.4259 32.4481 56.365C32.4481 56.304 32.4348 56.2437 32.4087 56.1875C32.3827 56.1312 32.3445 56.0803 32.2965 56.0375",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1314 56.7897C33.0599 56.725 32.9686 56.681 32.8694 56.6632C32.7701 56.6453 32.6673 56.6545 32.5737 56.6896C32.4802 56.7246 32.4004 56.784 32.3441 56.8601C32.2879 56.9362 32.2578 57.0257 32.2578 57.1172C32.2578 57.2087 32.2879 57.2982 32.3441 57.3743C32.4004 57.4504 32.4802 57.5097 32.5737 57.5448C32.6673 57.5798 32.7701 57.589 32.8694 57.5712C32.9686 57.5534 33.0599 57.5094 33.1314 57.4447C33.1794 57.4019 33.2176 57.3509 33.2436 57.2947C33.2697 57.2385 33.283 57.1781 33.283 57.1172C33.283 57.0562 33.2697 56.9959 33.2436 56.9397C33.2176 56.8835 33.1794 56.8325 33.1314 56.7897Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6315 56.035C30.56 55.9703 30.4689 55.9262 30.3695 55.9083C30.2702 55.8904 30.1673 55.8996 30.0738 55.9347C29.9802 55.9697 29.9004 56.029 29.844 56.1051C29.7878 56.1813 29.7578 56.2708 29.7578 56.3623C29.7578 56.4539 29.7878 56.5434 29.844 56.6195C29.9004 56.6956 29.9802 56.7549 30.0738 56.79C30.1673 56.825 30.2702 56.8342 30.3695 56.8163C30.4689 56.7984 30.56 56.7543 30.6315 56.6896C30.6796 56.6468 30.7176 56.5959 30.7436 56.5397C30.7697 56.4835 30.783 56.4232 30.783 56.3623C30.783 56.3014 30.7697 56.2411 30.7436 56.1849C30.7176 56.1287 30.6796 56.0778 30.6315 56.035Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4654 56.7882C31.3937 56.7236 31.3026 56.6795 31.2033 56.6617C31.104 56.6439 31.0011 56.6531 30.9077 56.6881C30.8141 56.7232 30.7342 56.7825 30.678 56.8586C30.6218 56.9347 30.5918 57.0242 30.5918 57.1157C30.5918 57.2073 30.6218 57.2967 30.678 57.3728C30.7342 57.449 30.8141 57.5083 30.9077 57.5433C31.0011 57.5784 31.104 57.5876 31.2033 57.5698C31.3026 57.5519 31.3937 57.5079 31.4654 57.4432C31.5132 57.4004 31.5512 57.3493 31.5772 57.2931C31.6031 57.2369 31.6164 57.1766 31.6164 57.1157C31.6164 57.0548 31.6031 56.9945 31.5772 56.9383C31.5512 56.8821 31.5132 56.8311 31.4654 56.7882Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2977 57.5423C32.2018 57.4555 32.0714 57.4067 31.9357 57.4067C31.7999 57.4067 31.6696 57.4555 31.5736 57.5423C31.502 57.6071 31.4534 57.6896 31.4336 57.7793C31.4139 57.8691 31.4241 57.9622 31.4628 58.0467C31.5016 58.1313 31.5672 58.2036 31.6513 58.2544C31.7356 58.3052 31.8345 58.3324 31.9357 58.3324C32.0369 58.3324 32.1358 58.3052 32.22 58.2544C32.3042 58.2036 32.3698 58.1313 32.4085 58.0467C32.4473 57.9622 32.4574 57.8691 32.4377 57.7793C32.4181 57.6896 32.3693 57.6071 32.2977 57.5423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8875 54.5C31.8 54.5001 31.7145 54.5236 31.6418 54.5676C31.5691 54.6116 31.5123 54.6742 31.479 54.7473C31.4455 54.8204 31.4368 54.9009 31.4538 54.9785C31.4709 55.0561 31.5131 55.1274 31.5749 55.1834C31.6161 55.2205 31.6649 55.2499 31.7185 55.27C31.7722 55.2901 31.8298 55.3004 31.8878 55.3004C31.9459 55.3003 32.0035 55.2899 32.0571 55.2698C32.1107 55.2497 32.1595 55.2202 32.2005 55.183C32.2416 55.1458 32.2741 55.1017 32.2963 55.0532C32.3185 55.0046 32.33 54.9526 32.33 54.9001C32.3298 54.8475 32.3184 54.7955 32.2961 54.747C32.2739 54.6985 32.2413 54.6544 32.2001 54.6173C32.1593 54.5799 32.1106 54.5503 32.0569 54.5302C32.0032 54.5101 31.9457 54.4998 31.8875 54.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3168_6832"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3168_6832"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(20 8.51367)"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPayshapInfo1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/payshap_info_1.03cba554.svg";
export { ForwardRef as ReactComponent };